import {Component, Input, OnInit} from '@angular/core';
import {CouponGridService} from "../../../shared/services/coupon-grid.service";
import {properties} from '../../../../environments/properties';


@Component({
    selector: 'app-freshpass-perks',
    templateUrl: './freshpass-perks.component.html',
    styleUrls: ['./freshpass-perks.component.scss']
})
export class FreshpassPerksComponent implements OnInit {

    @Input() coupons: any = [];
    @Input() userSubscriptionDetails: any;
    @Input() displayCreditPreview: boolean;
    @Input() currentEnvironment;
    isTrialPlan = false;

    properties = properties;

    public creditPreviewStatus: string;

    constructor(public couponGridService: CouponGridService) {
    }

    ngOnInit(): void {
        this.checkCreditPreviewStatus();
        this.isTrialPlan = this.getTrialPlanStatus(this.userSubscriptionDetails);
        this.checkUpgradeStatus();
    }

    getTrialPlanStatus(data) {
        if (data) {
            if ((data.status.toLowerCase() === this.properties.confirmation.TRIAL) || (data.status.toLowerCase() ===  this.properties.confirmation.PROCESSING && data.previousStatus && data.previousStatus.toLowerCase() === this.properties.confirmation.TRIAL)) {
                return true;
            }
        }

        return false;
    }

    checkCreditPreviewStatus() {
        if (this.userSubscriptionDetails) {
            if ((this.userSubscriptionDetails.subscriptionType === this.properties.confirmation.ANNUAL_PLAN && this.userSubscriptionDetails.subscriptionStatus === this.properties.confirmation.TRIAL.toUpperCase()) || this.userSubscriptionDetails.pendingSubscriptionType === this.properties.confirmation.ANNUAL_PLAN) {
                this.creditPreviewStatus = this.properties.confirmation.ANNUAL;
            } else {
                this.creditPreviewStatus = this.properties.confirmation.MONTHLY;
            }
        }
    }

    checkUpgradeStatus() {
        if (this.creditPreviewStatus ===this.properties.confirmation.MONTHLY  && this.isTrialPlan) {
            if (this.userSubscriptionDetails?.campaignRules?.showCampaignPlanOnly) {
                this.displayCreditPreview = false;
            }
        }
    }
}
